import config from "../../config/apiService.json";
import useData from "./useData";

const useStakeholders = () => {
  const { home } = config;
  const { stakeholders } = home;
  return useData(stakeholders);
};

export default useStakeholders;
